export default __webpack_public_path__ + "static/media/ts_black.eb67f2da.png";